import { Injectable } from '@angular/core';
import { LiabilityDataModel } from '../models/liability-data.model';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  constructor(private title: Title) {}

  private static getTitle(payment: LiabilityDataModel): string {
    return payment.brandId.startsWith('SHORTPAY::') ? 'Powiadomienia imoje' : 'BillTech Pay';
  }

  public setTitle(payment: LiabilityDataModel) {
    this.title.setTitle(TitleService.getTitle(payment));
  }
}
